import http from './reddit'
import qs from 'qs'
export default {
  /** 電子遊戲 (CQ9) */
  // 游戏商列表
  getElectronicGameMaker: () => http.Get(`${http.url.exgame}/halls`),
  // 游戏商修改
  modifyElectronicGameMaker: (data = {}) => http.Post(`${http.url.exgame}/hallsupd`, data),
  // 游戏商编号 游戏列表
  getElectronicGameList: (Makerid) => http.Get(`${http.url.exgame}/gamelist/${Makerid}`),
  // 修改遊戲列表啟用狀態
  modifyElectronicGameList: (data) => http.Post(`${http.url.exgame}/gameidopupd`, data),
  // 更新CQ9游戏
  refreshElectronicGameList: () => http.Post(`${http.url.exgame}/cq9gamelist`),
  // 取得 遊戲商大項玩法
  getpmtge: (Makerid) => http.Get(`${http.url.exgame}/pmtge`),
  // 各占点 游戏开关列表
  getSiteGameTriggerList: (siteid, companyid = 2) => http.Get(`${http.url.exgame}/gamememlist/${siteid}/${companyid}`),
  // 各站点 游戏开关修改
  modifySiteGameTrigger: (data) => http.Post(`${http.url.exgame}/gamememlistupd`, data),
  // 取得 各占点 游戏商列表
  getSiteElectronicGameMaker: (siteid) => http.Get(`${http.url.exgame}/hallsmemlist/${siteid}`),
  // 修改 各占点 游戏商开啟
  modifySiteElectronicGameMaker: (data = {}) => http.Post(`${http.url.exgame}/hallsmemupd`, data),
  // 取得 各占点 游戏列表大项开关
  getgamePJAllList: (obj) => {
    let str = qs.stringify(obj, { encode: false })
    return http.Get(`${http.url.exgame}/gamePJAllList?${str}`)
  },
  // 修改 各占点 游戏列表大项开关
  modifygamePJupdop: (data = {}) => http.Post(`${http.url.exgame}/gamePJupdop`, data),
}